import React from 'react';
import InputError from './InputError';

import './Input.css';

interface Props {
  // value: string | number;
  inputType: string;
  name: string;
  isFormGroup?: boolean;
  isSmall?: boolean;
  isNextSmall?: boolean;
  placeholder?: string | null;
  formik: any;
  attributes?: any;
  inputChangeCallback?: () => void;
  additionalClasses?: string;
}

const Input: React.FC<Props> = props => {
  const {
    isFormGroup,
    isSmall,
    inputType,
    placeholder,
    name,
    formik,
    isNextSmall,
    attributes = {},
    inputChangeCallback,
    additionalClasses,
  } = props;
  // const { configuration } = useContext(CommonContext);

  return (
    <label
      className={`ui-widget-label ui-widget-label${isSmall ? '-small' : '-big'} ui-widget-label${
        isNextSmall ? '-next-small' : '-next-big'
      } ${formik.touched[name] && formik.errors[name] ? 'ui-widget-label-error' : ''} ${
        isFormGroup ? 'ui-widget-label-group' : 'ui-widget-label-not-group'
      } ${additionalClasses}`}
    >
      {/*<p className="ui-widget-label-text" style={{ color: (configuration?.PrimaryColor as string) || PRIMARY_COLOR }}>*/}
      {/*  {placeholder}*/}
      {/*</p>*/}
      <input
        className="ui-widget-input"
        type={inputType}
        placeholder={placeholder || ''}
        {...formik.getFieldProps(name)}
        onChange={e => {
          formik.handleChange(e);
          inputChangeCallback?.();
        }}
        {...attributes}
      />
      <InputError formik={formik} name={name} isFormGroup={isFormGroup} />
    </label>
  );
};

export default Input;
